import React, { useContext, useEffect, useState } from 'react'
import ReactStars from 'react-rating-stars-component'
import { captureGAEvent, raiseToast } from '../../utils/helper'
import { isEmpty } from 'lodash'
import useAxios from 'axios-hooks'
import { GET_REVIEWS_API } from '../../utils/apiUrls'
import { AppContext } from '../../context/app'
import { withTheme } from 'theming'
import { useTranslation } from 'react-i18next'
import CloseIcon from '../../assets/close-icon-white.svg'

const RatingPostModal = (props) => {
  const { type, id, handleClose, title, onReviewed, alreadyReviewed, theme } = props
  const [reviewRating, setReviewRating] = useState(0)
  const [isEdit, setIsEdit] = useState(false)
  //   const [isUpdated, setIsUpdated] = useState(false)
  const { setLoader, isCustomTemplate, userObj } = useContext(AppContext)
  const { t } = useTranslation()

  useEffect(() => {
    if (!isEmpty(alreadyReviewed)) {
      setReviewRating(alreadyReviewed.rating)
      setIsEdit(true)
    }
  }, [alreadyReviewed])

  const [{ data: createReview, loading: createReviewLoading }, postReview] = useAxios(
    {
      url: GET_REVIEWS_API + '/' + type + '/' + id,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateReview, loading: updateReviewLoading }, updateReviewCall] = useAxios(
    {
      url: GET_REVIEWS_API + '?review_id=' + alreadyReviewed._id,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(createReviewLoading || updateReviewLoading)
  }, [createReviewLoading, updateReviewLoading])

  useEffect(() => {
    if (createReview && createReview.success) {
      raiseToast('success', t('review_success'))
      onReviewed()
      handleClose()
    }
  }, [createReview])

  useEffect(() => {
    if (updateReview && updateReview.success) {
      raiseToast('success', t('review_update_success'))
      onReviewed()
      handleClose()
    }
  }, [updateReview])

  const onClickSubmit = () => {
    if (reviewRating < 0.5) {
      raiseToast('error', t('provide_rating'))
    } else {
      if (isEdit) {
        updateReviewCall({
          data: {
            title: '',
            description: '',
            rating: reviewRating,
          },
        })
      } else {
        captureGAEvent('review', 'review', 'Review', {
          content_id: id,
          user_id: userObj?._id || '',
          user_email: userObj?.email_id || '',
        })
        postReview({
          data: {
            title: '',
            description: '',
            rating: reviewRating,
          },
        })
      }
    }
  }

  return (
    <>
      <div
        style={{ backgroundColor: isCustomTemplate ? `${theme.c1}90` : 'rgb(17 ,24, 39,0.9)' }}
        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
      >
        <div className={`relative w-11/12  xl:w-[743px] md:w-2/4 my-2 mx-auto`}>
          <div
            style={{
              background: `#0f1113`,
              fontFamily: 'Arial',
              boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.8), 0 6px 20px 0 rgba(0, 0, 0, 0.60)',
              border: '',
            }}
            className="shadow-lg relative flex flex-col md:w-full rounded-lg overflow-hidden"
          >
            <div
              style={{ background: '#161c23' }}
              className="py-2 flex justify-center items-center relative "
            >
              <button className="absolute right-0 px-2 " onClick={handleClose}>
                <img src={CloseIcon} alt="Close" className="h-6 w-6" />
              </button>
              <div className="flex flex-col justify-center">
                <h4
                  style={{ color: isEdit ? `#0ed200` : '#ffd700' }}
                  className=" text-sm md:text-xl  font-semibold"
                >
                  {isEdit ? `THANK YOU !` : `PLEASE RATE YOUR EXPERIENCE`}
                </h4>
              </div>
            </div>
            <div className="p-5 flex flex-col items-center justify-center">
              <p className="w-full text-center text-white text-lg xl:text-3xl">{title}</p>
              <div className="mt-8">
                <ReactStars
                  count={5}
                  size={42}
                  activeColor={'#ffd700'}
                  value={!isEmpty(alreadyReviewed) ? alreadyReviewed.rating : reviewRating}
                  edit={true}
                  onChange={(val) => setReviewRating(val)}
                  isHalf={true}
                />
              </div>

              <div className={'mt-8'}>
                <div
                  style={{
                    border: `1px solid ${isEdit ? '#818181' : '#bbfa33'}`,
                    color: isEdit ? '#818181' : '#bbfa33',
                    borderRadius: '8px',
                  }}
                  className="cursor-pointer flex items-center text-center rounded text-sm md:text-base xl:text-lg px-4 py-2"
                  onClick={onClickSubmit}
                >
                  {isEdit ? 'Rating Submitted' : t('submit')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default withTheme(RatingPostModal)
